import { createContext, useContext, useState, useEffect, useCallback, type ReactNode } from 'react';
import { settingsService } from '../services/settings.service';

interface TimezoneContextType {
  timezone: string;
  setTimezone: (tz: string) => void;
}

const TimezoneContext = createContext<TimezoneContextType>({ timezone: 'UTC', setTimezone: () => {} });

export function TimezoneProvider({ children }: { children: ReactNode }) {
  const [timezone, setTz] = useState('UTC');

  const fetchTimezone = useCallback(async () => {
    try {
      const tz = await settingsService.getTimezone();
      setTz(tz);
    } catch {
      // keep UTC default
    }
  }, []);

  useEffect(() => { fetchTimezone(); }, [fetchTimezone]);

  const setTimezone = useCallback((tz: string) => { setTz(tz); }, []);

  return (
    <TimezoneContext.Provider value={{ timezone, setTimezone }}>
      {children}
    </TimezoneContext.Provider>
  );
}

export function useTimezone() {
  return useContext(TimezoneContext);
}
